import React from 'react';
export function TeenAddictionSection() {
  const stats = [{
    number: '5+ hrs',
    label: 'Average daily phone exposure for addicted teens',
    color: '#E67E22'
  }, {
    number: '24/7',
    label: 'Constant EMF radiation from WiFi & 5G',
    color: '#1B4F9E'
  }];
  return <section className="w-full py-8 md:py-12 lg:py-16 px-4 md:px-6" style={{
    background: 'linear-gradient(180deg, #FFFFFF 0%, #F8F9FA 100%)',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
  }} data-id="element-197">
      <div className="max-w-4xl mx-auto" data-id="element-198">
        <h2 className="text-[29px] md:text-[34px] lg:text-[43px] font-bold mb-8" style={{
        color: '#1B4F9E'
      }} data-id="element-199">
          WHY YOUR TEENAGER CAN'T STOP SCROLLING (And What It's Costing)
        </h2>

        <div className="my-8" data-id="element-200">
          <img src="https://cdn.magicpatterns.com/uploads/38g4a9gFQvRm8oCVHkTfJ1/unnamed_(1).jpg" alt="Teenager illuminated by smartphone screen glow in the dark, showing digital addiction at night" className="w-full max-w-[600px] mx-auto rounded-lg shadow-lg" style={{
          boxShadow: '0px 8px 24px rgba(27, 79, 158, 0.12)'
        }} data-id="element-201" />
        </div>

        <div className="text-base md:text-lg leading-relaxed space-y-5 mb-8" style={{
        color: '#2C3E50',
        lineHeight: '1.7'
      }} data-id="element-202">
          <p data-id="element-203">
            Here's what experts won't tell you: Social media apps are{' '}
            <strong data-id="element-204">deliberately designed to be addictive.</strong> Former
            Facebook and TikTok engineers have publicly admitted this. The
            variable reward schedule (never knowing when the next like/comment
            arrives) triggers dopamine release in the same way slot machines do.
            Notifications are push notifications constant stimulation engineered
            to interrupt sleep.
          </p>

          <p data-id="element-205">
            Meanwhile, your teenager is holding a small electromagnetic
            radiation transmitter <strong data-id="element-206">6 inches from their brain.</strong>
          </p>

          <p className="font-semibold" data-id="element-207">For 5+ hours daily.</p>

          <p className="font-semibold" data-id="element-208">
            While it's actively trying to hijack their attention.
          </p>

          <p data-id="element-209">
            The result? <strong data-id="element-210">Exhausted teens. Brain fog. Anxiety.</strong>{' '}
            Inability to concentrate on schoolwork. Behavioral issues parents
            can't explain.
          </p>

          <p data-id="element-211">
            And doctors don't test for EMF exposure. So they{' '}
            <strong data-id="element-212">
              prescribe anxiety medication instead of addressing the root cause.
            </strong>
          </p>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 my-10" data-id="element-213">
          {stats.map((stat, index) => <div key={index} className="bg-white border border-gray-200 rounded-lg p-6 text-center" data-id="element-214">
              <div className="text-4xl font-bold mb-2" style={{
            color: stat.color
          }} data-id="element-215">
                {stat.number}
              </div>
              <div className="text-sm" style={{
            color: '#2C3E50'
          }} data-id="element-216">
                {stat.label}
              </div>
            </div>)}
        </div>

        {/* Image above mechanism */}
        <div className="my-8" data-id="element-217">
          <img src="https://cdn.magicpatterns.com/uploads/hFySuTCw9TCdLFjz2nWZGV/unnamed_(2).jpg" alt="Teen sleeping with phone on chest, EMF exposure during sleep" className="w-full max-w-[600px] mx-auto rounded-lg shadow-lg" style={{
          boxShadow: '0px 8px 24px rgba(27, 79, 158, 0.12)'
        }} data-id="element-218" />
        </div>

        {/* Mechanism Section */}
        <h3 className="text-[24px] md:text-[29px] font-semibold mt-10 mb-5" style={{
        color: '#1B4F9E'
      }} data-id="element-219">
          Here's the mechanism:
        </h3>

        <div className="text-base md:text-lg leading-relaxed space-y-5" style={{
        color: '#2C3E50',
        lineHeight: '1.7'
      }} data-id="element-220">
          <p data-id="element-221">
            When your teenager is exposed to constant WiFi and 5G radiation, it{' '}
            <strong data-id="element-222">disrupts melatonin production.</strong> Their brain stays in
            an "alert" state even when they're trying to sleep. Their stress
            hormones (cortisol) stay elevated longer than they should.
          </p>

          <p className="font-semibold" data-id="element-223">So what happens?</p>

          <p data-id="element-224">
            While they're glued to the phone, that same EMF radiation is
            disrupting their melatonin further, making sleep even more
            impossible.
          </p>

          <p data-id="element-225">
            This is why removing the phone alone doesn't work. And why limiting
            screen time alone doesn't work.
          </p>

          <p className="font-semibold" data-id="element-226">
            That's the missing piece nobody connects.
          </p>
        </div>

        {/* Vicious Cycle Infographic */}
        <div className="my-10 -mx-4 md:-mx-6" data-id="element-227">
          <img src="https://cdn.magicpatterns.com/uploads/5TiqgmDQg4AEA5gj5iSJcj/unnamed_(4).jpg" alt="Reinforcing cycle diagram: EMF disrupts sleep, brain impaired judgment, vulnerable to addiction, more phone use, more EMF exposure" className="w-full" style={{
          boxShadow: '0px 8px 24px rgba(27, 79, 158, 0.12)'
        }} data-id="element-228" />
        </div>
      </div>
    </section>;
}